var _rect, _circle, _circle2, _path, _path2, _circle3, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _path6, _path7, _path8, _circle4, _path9, _path10, _path11, _path12, _path13, _rect6, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    rx: 36,
    fill: "#F6FBFE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 450,
    r: 170,
    fill: "#132238"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 450,
    r: 106,
    fill: "#0F766E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430 450H774",
    stroke: "white",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M602 278V622",
    stroke: "white",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 450,
    r: 34,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 156,
    width: 250,
    height: 138,
    rx: 28,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 836,
    y: 156,
    width: 250,
    height: 138,
    rx: 28,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 608,
    width: 250,
    height: 138,
    rx: 28,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 836,
    y: 608,
    width: 250,
    height: 138,
    rx: 28,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366 222L490 354",
    stroke: "#0F766E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M836 222L714 354",
    stroke: "#0F766E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366 676L490 546",
    stroke: "#0F766E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M836 676L714 546",
    stroke: "#0F766E",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174 212H306",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174 252H272",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 214,
    r: 24,
    stroke: "#0F766E",
    strokeWidth: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M894 212H1026",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M894 252H992",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M936 190V238",
    stroke: "#F59E0B",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174 664H306",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174 704H284",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 640,
    width: 52,
    height: 52,
    rx: 16,
    stroke: "#6D57D4",
    strokeWidth: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M894 664H1026",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M894 704H980",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M920 646L964 690L920 734",
    stroke: "#C2410C",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderNetwork);
export default __webpack_public_path__ + "static/media/provider-network.303068606ed0960dd21e38ddf2430c73.svg";
export { ForwardRef as ReactComponent };